import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { WhatsAppButton } from '../common/buttons';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow mt-[56px] md:mt-[76px]"><Outlet /></main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
